/*
 * Русский язык интерфейса: переводы плагинов Backstage, которые используются в приложении.
 * Подключаются в createApp (__experimentalTranslations, язык по умолчанию — ru); ключи,
 * которых здесь нет, показываются по-английски из плагина. Собственные страницы платформы
 * (главная, разделы, карточки) написаны по-русски напрямую.
 */
import { catalogTranslations } from './catalog';
import { coreTranslations } from './core';
import { scaffolderTranslations } from './scaffolder';
import { searchTranslations } from './search';
import { settingsTranslations } from './settings';
import { techdocsTranslations } from './techdocs';
import { toolsTranslations } from './tools';

export const translationResources = [
  ...coreTranslations,
  ...catalogTranslations,
  ...scaffolderTranslations,
  ...searchTranslations,
  ...techdocsTranslations,
  ...settingsTranslations,
  ...toolsTranslations,
];
